import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import type { AdminDict } from "@/lib/admin-i18n";

export function AdminLogin({ t, onSignedIn }: { t: AdminDict; onSignedIn: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) { setError(error.message); return; }
    onSignedIn();
  }

  return (
    <div className="mx-auto max-w-sm px-6 py-20">
      <h1 className="font-display text-3xl" style={{ color: "var(--ink)" }}>{t.sign_in}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{t.sign_in_lead}</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <label className="block text-sm">
          <span className="text-muted-foreground">{t.email}</span>
          <input
            type="email" required autoComplete="email" value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded-sm border border-border bg-background px-3 py-2 text-sm"
          />
        </label>
        <label className="block text-sm">
          <span className="text-muted-foreground">{t.password}</span>
          <input
            type="password" required autoComplete="current-password" value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded-sm border border-border bg-background px-3 py-2 text-sm"
          />
        </label>
        {error && (
          <p className="text-sm" style={{ color: "var(--rust)" }}>{error}</p>
        )}
        <button
          type="submit" disabled={busy}
          className="w-full rounded-full px-4 py-2 text-sm font-medium disabled:opacity-50"
          style={{ background: "var(--amber)", color: "var(--ink)" }}
        >
          {busy ? "…" : t.sign_in_btn}
        </button>
      </form>
    </div>
  );
}